import React, { useEffect, useState } from 'react';

export default function ConsultNoteEditModal({ open, onClose, initialContent = '', title = '상담내역 편집', saving = false, onSave }) {
  const [content, setContent] = useState(String(initialContent || ''));

  useEffect(() => {
    if (open) setContent(String(initialContent || ''));
  }, [open, initialContent]);

  if (!open) return null;

  const handleSave = () => {
    const text = String(content || '').trim();
    if (!text) return;
    if (typeof onSave === 'function') onSave(text);
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white w-full max-w-xl max-h-[90vh] rounded-2xl shadow-2xl overflow-hidden flex flex-col">
        <div className="flex items-center justify-between px-6 pt-5 pb-3">
          <div className="text-[17px] font-bold text-gray-900">{title}</div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100">✕</button>
        </div>
        <div className="px-6 py-4 flex-1 overflow-y-auto">
          <label className="block text-[13px] font-semibold text-gray-600 mb-1">내용</label>
          <textarea
            rows={10}
            className="w-full border border-gray-300 rounded-lg bg-white px-2.5 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 resize-y"
            placeholder="상담 내용을 입력하세요."
            value={content}
            onChange={(e)=>setContent(e.target.value)}
          />
          <div className="text-[11px] text-gray-500 mt-1">저장 시 상담내역 목록에 반영됩니다.</div>
        </div>
        <div className="flex items-center justify-end gap-2 px-6 pb-5 pt-3">
          <button onClick={onClose} className="h-9 px-3.5 rounded-lg text-sm font-semibold bg-gray-100 text-gray-900 hover:bg-gray-200">취소</button>
          <button onClick={handleSave} disabled={saving || !String(content || '').trim()} className="h-9 px-3.5 text-sm font-semibold rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50">{saving ? '저장 중...' : '저장'}</button>
        </div>
      </div>
    </div>
  );
}
